import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <main className="not-found-page">
      <section className="not-found-card" aria-labelledby="not-found-title">
        <div className="not-found-code" aria-hidden="true">404</div>
        <h1 id="not-found-title">Đường dẫn không tồn tại</h1>
        <p>Trang bạn đang tìm kiếm không tồn tại hoặc đã được di chuyển.</p>
        <Link className="not-found-home-link" to="/">
          Quay về trang chủ
        </Link>
      </section>
    </main>
  );
};

export default NotFoundPage;
